<template>
    <div class="u-card__meta">
        <div class="u-card__meta-value" v-if="!consultation.anonym">
            <template v-if="!consultation.patient.user.deleted_at">
                <a :href="consultation.family ? '/family/' + consultation.family.slug : '/patient/' + consultation.patient.id">
                    <span>{{ consultation.family ? consultation.family.name : consultation.patient.user.name }}</span>
                </a>
            </template>
            <template v-else>
                <span>{{ consultation.family ? consultation.family.name : consultation.patient.user.name }}</span>
            </template>
        </div>
        <div class="u-card__meta-value" v-else>
            <span>Аноним</span>
        </div>
        <div class="u-card__meta-name">
            <span>Пациент</span>
        </div>
    </div>
</template>

<script>
    import dayjs from "dayjs";
    import utc from 'dayjs/plugin/utc';
    import api from "../../../../admin/api/api";

    dayjs.extend(utc);

    export default {
        name: "CardMeta",
        props: {
            consultation: {
                type: Object,
                required: true
            },
        },
    }
</script>
